import type { GlucoseSpecialValue } from "@tandemdiabetes/sugarmate-api-react-client"
import { useDisplayGlucoseString } from "./useDisplayGlucoseString"

export function useReadableGlucoseString(value: number, specialValue?: GlucoseSpecialValue): string {
  const displayGlucoseString = useDisplayGlucoseString()
  return displayGlucoseString(
    value,
    specialValue,
  )
}
